import { HelmetDexteel } from "@dexteel/mesf-core";
import { PurchaseOrdersManager } from "./components/PurchaseOrdersManager";

export const PurchaseOrdersPage = () => {
	return (
		<>
			<HelmetDexteel title="Purchase Orders" />
			<PurchaseOrdersManager />
		</>
	);
};
